import client from 'app/client';

/** Portée d'un contrat collectif — miroir de l'enum backend ScopeContratGroupe. */
export enum GroupContractScope {
  PersonneMorale = 'PersonneMorale',
  Plateforme = 'Plateforme',
}

/** Origine de l'éligibilité d'un souscripteur. */
export type EligibleSubscriberSource = 'CABINET' | 'PORTEFEUILLE_PARTAGE';

export interface EligibleSubscriberDto {
  personId: string;
  /** "LEGAL" (personne morale) ou "PHYSICAL" (personne physique). */
  type: 'LEGAL' | 'PHYSICAL';
  name: string;
  siret?: string | null;
  source: EligibleSubscriberSource;
}

export interface SearchEligibleSubscribersResponse {
  totalCount: number;
  items: EligibleSubscriberDto[];
}

/**
 * Recherche paginée des personnes éligibles comme souscripteur du contrat,
 * bornée à sa portée (cabinet ∪ portefeuille partagé, ou portefeuille partagé seul).
 */
export async function searchEligibleSubscribers(
  contractId: string,
  searchString: string,
  pageNumber = 1,
  pageSize = 20,
): Promise<SearchEligibleSubscribersResponse> {
  const { data } = await client.post<SearchEligibleSubscribersResponse>(
    `/backoffice/contrats/groupes/${contractId}/souscripteurs-eligibles`,
    { searchString, pageNumber, pageSize },
  );
  return data;
}

export interface CreateGroupContractPayload {
  /** "G" (groupe) ou "C" (cadre). */
  type: string;
  plateformeId?: string;
}

export interface CreateGroupContractResult {
  isSuccess?: boolean;
  errorMessage?: string;
  id?: string;
}

/**
 * Crée un contrat collectif (brouillon). La portée n'est pas envoyée : le back la
 * déduit du contexte (courtier → PersonneMorale, compagnie/admin → Plateforme).
 */
export async function createGroupContract(
  payload: CreateGroupContractPayload,
): Promise<CreateGroupContractResult> {
  const { data } = await client.post<CreateGroupContractResult>(
    '/backoffice/contrats/groupes/create',
    payload,
  );
  return data;
}
